import React, { useState, useEffect } from 'react';
import { getAllStudents } from '../services/userService';
import './StudentTierModal.css';

const ACTIVITY_LABEL = {
  sight: 'Sight Words',
  scramble: 'Scramble Words',
  category: 'Category Words',
};

const StudentTierModal = ({ activityType, tier, tierLabel, grantedStudents, onToggle, onClose }) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [saving, setSaving] = useState(new Set());

  useEffect(() => {
    getAllStudents().then(({ data }) => {
      setStudents((data || []).filter(s => s.is_active));
      setLoading(false);
    });
  }, []);

  const handleToggle = async (student) => {
    const granted = grantedStudents.has(student.id);
    setSaving(prev => new Set([...prev, student.id]));
    await onToggle(student.id, granted);
    setSaving(prev => { const s = new Set(prev); s.delete(student.id); return s; });
  };

  const filtered = students.filter(s => {
    const name = `${s.first_name} ${s.last_name} ${s.username}`.toLowerCase();
    return name.includes(search.toLowerCase());
  });

  const grantedCount = students.filter(s => grantedStudents.has(s.id)).length;

  return (
    <div className="stm-overlay" onClick={onClose}>
      <div className="stm-modal" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="stm-header">
          <div>
            <h3>{ACTIVITY_LABEL[activityType]} — Tier {tier}</h3>
            <p>{tierLabel} · {grantedCount} of {students.length} student{students.length !== 1 ? 's' : ''} assigned</p>
          </div>
          <button className="stm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        {/* Search */}
        <div className="stm-search">
          <input
            type="text"
            placeholder="Search students…"
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="stm-search-input"
          />
        </div>

        {/* Student list */}
        <div className="stm-list">
          {loading && <p className="stm-empty">Loading students…</p>}
          {!loading && filtered.length === 0 && (
            <p className="stm-empty">No students found.</p>
          )}
          {!loading && filtered.map(student => {
            const granted = grantedStudents.has(student.id);
            const isSaving = saving.has(student.id);
            return (
              <div key={student.id} className={`stm-row ${granted ? 'granted' : ''}`}>
                <div className="stm-student-info">
                  <div className="stm-avatar">
                    {student.first_name?.[0]}{student.last_name?.[0]}
                  </div>
                  <div>
                    <p className="stm-name">{student.first_name} {student.last_name}</p>
                    <p className="stm-username">@{student.username}</p>
                  </div>
                </div>
                <button
                  className={`stm-toggle-btn ${granted ? 'revoke' : 'grant'}`}
                  onClick={() => handleToggle(student)}
                  disabled={isSaving}
                >
                  {isSaving ? '…' : granted ? '✓ Assigned' : '+ Assign'}
                </button>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="stm-footer">
          <button className="stm-done-btn" onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default StudentTierModal;
